import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import toastError from '../../toasts/toastError';

import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Link,
  TextField,
  Typography,
  Fade,
  Grow,
  LinearProgress,
  useTheme,
} from '@mui/material';

import api from '../../services/api';
import { getStyled } from './styles';

const EsqueciSenha = () => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const [email, setEmail] = useState('');
  const [visivel, setVisivel] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  React.useEffect(() => {
    setVisivel(true);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setEnviando(false);
      setEnviado(true);
      toastSuccess('Link de redefinição de senha enviado com sucesso');
      setTimeout(() => setEnviado(false), 2000); // Reset após 2 segundos
    } catch (err) {
      setEnviando(false);
      toastError(err);
    }
  };

  return (
    <div style={classes.root}>
      <CssBaseline />
      <Fade in={visivel} timeout={1000}>
        <Container sx={classes.container} maxWidth='xs'>
          <Grow in={visivel} timeout={1200}>
            <Box sx={classes.formBox}>
              <Typography variant='h4' sx={classes.title}>
                Redefinir Senha
              </Typography>
              <form style={classes.form} noValidate onSubmit={handleSubmit}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  required
                  fullWidth
                  id='email'
                  label='Digite seu e-mail'
                  name='email'
                  autoComplete='email'
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={theme.custom.textField}
                  disabled={enviando}
                />
                <Button
                  type='submit'
                  fullWidth
                  variant='outlined'
                  sx={[classes.submitButton, enviado && classes.sentAnimation]}
                  disabled={enviando || enviado}
                >
                  {enviando
                    ? 'Enviando...'
                    : enviado
                      ? 'Enviado!'
                      : 'Enviar Link de Redefinição'}
                  {enviando && <LinearProgress sx={classes.loadingBar} />}
                </Button>
                <Grid
                  container
                  justifyContent='center'
                  sx={{ marginTop: theme.spacing(2) }}
                >
                  <Grid>
                    <Link component={RouterLink} to='/login' sx={classes.link}>
                      Voltar ao Login
                    </Link>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grow>
        </Container>
      </Fade>
    </div>
  );
};

export default EsqueciSenha;
